"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarYearPicker = void 0;
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
const react_1 = __importDefault(require("react"));
const lab_1 = require("@mui/lab");
const WithBaseCalendarDatePicker_1 = require("../WithBaseCalendarDatePicker");
/**
 * Year wise date picker
 */
exports.CalendarYearPicker = WithBaseCalendarDatePicker_1.withBaseCalendarDatePicker((props) => (react_1.default.createElement(lab_1.DatePicker, Object.assign({}, props, { views: ['year'], openTo: "year", inputFormat: "yyyy" }))));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FsZW5kYXJZZWFyUGlja2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NhbGVuZGFyL2RhdGUtcGlja2VyL3BpY2tlcnMvQ2FsZW5kYXJZZWFyUGlja2VyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7Ozs7O0dBTUc7QUFDSCxrREFBMEI7QUFDMUIsa0NBQXVEO0FBRXZELDhFQUEyRTtBQUUzRTs7R0FFRztBQUNVLFFBQUEsa0JBQWtCLEdBQUcsdURBQTBCLENBQUMsQ0FBQyxLQUFzQixFQUFFLEVBQUUsQ0FBQyxDQUN2Riw4QkFBQyxnQkFBVSxvQkFBSyxLQUFLLElBQUUsS0FBSyxFQUFFLENBQUMsTUFBTSxDQUFDLEVBQUUsTUFBTSxFQUFDLE1BQU0sRUFBQyxXQUFXLEVBQUMsTUFBTSxJQUFHLENBQzVFLENBQUMsQ0FBQyJ9